class LevsoxMotion {
  constructor() {
    this.observer = null;
  }

  init() {
    const elements = document.querySelectorAll('[data-levsox-reveal]:not(.is-visible)');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible', 'is-settled'));
      return;
    }

    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    elements.forEach((element) => this.observer.observe(element));
  }

  reveal(element) {
    let fallbackTimer;

    const settle = () => {
      window.clearTimeout(fallbackTimer);
      element.removeEventListener('transitionend', onTransitionEnd);
      element.classList.add('is-settled');
    };

    const onTransitionEnd = (event) => {
      if (event.target === element && event.propertyName === 'transform') settle();
    };

    element.addEventListener('transitionend', onTransitionEnd);
    element.classList.add('is-visible');
    fallbackTimer = window.setTimeout(settle, 700);
  }
}

const levsoxMotion = new LevsoxMotion();

document.addEventListener('DOMContentLoaded', () => levsoxMotion.init(), { once: true });
document.addEventListener('shopify:section:load', () => levsoxMotion.init());
